import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HreflangTags = () => {
  const location = useLocation();
  const baseUrl = 'https://chatity.io';

  useEffect(() => {
    // Get current path
    const currentPath = location.pathname;

    // Blog posts manage their own slug-aware hreflang/canonical (BlogPost.js).
    // Private/non-indexable pages don't need hreflang at all.
    const skipPrefixes = ['/blog/', '/dashboard', '/admin', '/auth', '/partner'];
    if (skipPrefixes.some(p => currentPath.startsWith(p))) {
      return;
    }

    // Remove existing hreflang tags
    const existingTags = document.querySelectorAll('link[rel="alternate"][hreflang]');
    existingTags.forEach(tag => tag.remove());
    
    // Define languages
    const languages = ['en', 'fr', 'ru'];
    
    // Create hreflang tags for each language
    languages.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      link.href = `${baseUrl}${currentPath}?lang=${lang}`;
      document.head.appendChild(link);
    });

    // Add x-default for international targeting
    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = `${baseUrl}${currentPath}`;
    document.head.appendChild(defaultLink);

    // Add canonical tag
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${baseUrl}${currentPath}`;

  }, [location.pathname]);

  return null;
};

export default HreflangTags;
